<template fluid>
  <v-container fluid class="pt-0 mt-0">
    <v-form ref="userForm">
      <v-row>
        <v-spacer />
        <v-col cols="12" md="11">
          <v-card class="mx-auto">
            <v-toolbar color="teal" dark class="text-xs-center">
              <v-select class="ma-2 pa-2" :items="folders" item-text="name" item-value="id" v-model="folder"
                label="Folder" hide-details @change="getMail()">
              </v-select>
              <v-spacer />
              <v-checkbox class="ma-2 pa-2" hide-details v-model="unreadOnly" label="Unread Only" />
              <v-spacer />
              <v-text-field v-if="!smallScreen" hide-details v-model="searchText" label="Search..." class="ma-2 pa-2">
              </v-text-field>
              <v-btn v-if="!smallScreen" icon>
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
              <v-btn class="ma-2" outlined @click="writeNewMail()">
                {{ newMailText }}
                <i aria-hidden="true" class="ma-2 v-icon notranslate v-icon--center mdi mdi-email-newsletter theme--light"
                  style="font-size: 16px"></i>
              </v-btn>
            </v-toolbar>
          </v-card>
        </v-col>
        <v-spacer />
      </v-row>

      <v-row>
        <v-spacer />
        <v-col cols="12" md="11" v-if="this.filteredInbox">
          <v-data-table id="content" :headers="getHeaders" :items="filteredInbox" :items-per-page="25" :must-sort="true"
            :sort-by="'messageDate'" :sort-desc="true" :search="searchText" :custom-sort="customSort"
            :custom-filter="customFilter" :footer-props="{ 'items-per-page-options': [10, 25, 50, 100, -1] }"
            class="elevation-1" dense @click:row="mailSelected">
            <template v-slot:item.actions="{ item }">
              <v-icon small @click.stop="deleteItem(item)"> mdi-delete </v-icon>
            </template>
            <template v-slot:item.message="{ item }">
              <span v-html="formatMailTextForDisplay(item)" />"
            </template>
            <template v-slot:item.userFrom="{ item }">
              <span :class="getUnreadStyle(item)">
                {{ item.userFromForename }} {{ item.userFromSurname }}
              </span>
            </template>
            <template v-slot:item.userTo="{ item }">
              <span :class="getUnreadStyle(item)">
                {{ item.userToForename }} {{ item.userToSurname }}
              </span>
            </template>
            <template v-slot:item.messageDate="{ item }">
              <span style="white-space: nowrap">
                {{ formatPalmDateTime(item.messageDate, item.messageTime) }}</span>
            </template>
          </v-data-table>

          <v-dialog v-model="showMailDialog" :retain-focus="false">
            <v-row style="margin-left: 0; margin-right: 0">
              <v-col cols="12">
                <v-card class="ma-2 pa-2">
                  <v-card-text class="mt-0 pt-0 mb-0 pb-0" v-if="selectedMailItem && !(showReply || showNew)" outline>
                    <!-- <h3> -->
                    <v-row>
                      <v-col cols="12" md="6" class="black-text">
                        Mail From: {{ selectedMailItem.userFromSurname }},
                        {{ selectedMailItem.userFromForename }}</v-col>
                      <v-col cols="12" md="6" class="black-text" style="white-space: nowrap">Mail To: {{
                        selectedMailItem.userToSurname }},
                        {{ selectedMailItem.userToForename }}</v-col>
                    </v-row>
                    <!-- </h3> -->
                  </v-card-text>
                  <v-card-text class="mt-0 pt-0 mb-0 pb-0 black-text" v-if="selectedMailItem && showReply" outline>
                    <!-- <h3> -->
                    Reply To: {{ getReplyUsername }}
                    <!-- </h3> -->
                  </v-card-text>
                  <v-card-text class="mt-0 pt-0 mb-0 pb-0 black-text" v-if="selectedMailItem && !(showReply || showNew)"
                    outline>
                    <v-row>
                      <v-col cols="12" md="6" class="black-text">
                        Subject: {{ selectedMailItem.subject }}</v-col>
                      <v-col cols="12" md="6" style="white-space: nowrap" class="black-text">Sent:
                        {{
                          formatPalmDateTime(
                            selectedMailItem.messageDate,
                            selectedMailItem.messageTime
                          )
                        }}</v-col>
                    </v-row>
                  </v-card-text>

                  <!-- <v-row>
                  <v-spacer />
                  <v-col cols="12"> -->
                  <v-card v-if="selectedMailItem && !showReply" elevation="4" class="pa-2 ma-2">
                    <v-row>
                      <v-col cols="12">
                        <v-card-text class="pa-2 ma-2 scroll black-text" style="max-height: 400px">
                          <span v-html="formatMailTextForDisplay(selectedMailItem)" />
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </v-card>

                  <v-card-text v-if="showReply || showNew" class="pl-2 pr-2 pt-0 pb-0 mt-0 mb-0">
                    <v-row>
                      <v-col cols="12">
                        <v-text-field class="pa-0" clearable outlined :rules="[rules.required]" shaped persistent-hint
                          label="Subject" hint="Subject should be no more than 150 characters" counter="150"
                          v-model="mailSubject">
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row v-if="showNew">
                      <v-col cols="12">
                        <v-autocomplete class="pa-0" v-model="toUser" :items="users" :item-text="getUsersName"
                          item-value="userId" dense outlined label="Recipient">
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <editor class="pa-0" ref="editorElement"
                          api-key="obkrlht14x57mdol58bxqewvhlp88c5lwfj2i9d770gpxomq" initial-value="<br/>"
                          v-model="editorContent" id="contentEditor" :init="{
                            height: 350,
                            menubar: false,
                            toolbar_mode: 'wrap',
                            mobile: {
                              toolbar_mode: 'wrap',
                            },
                            setup: function (editor) {
                              editor.on('init', function (e) {
                                focusEditor(e);
                                editor.execCommand('mceFocus');
                              });
                            },
                            plugins: ['emoticons', 'lists', 'advlist', 'link', 'anchor', 'image', 'media', 'help'],
                            toolbar:
                              ' undo redo bold italic underline fontsize forecolor | bullist emoticons | copy paste pastetext | link image media | help', // 
                            help_tabs: [
                              'shortcuts'],
                            contextmenu: false,
                            content_css: false,
                            browser_spellcheck: true,
                            skin: false,
                            content_style:
                              contentUiCss.toString() + '\n' + contentCss.toString(),
                            smart_paste: true,
                            paste_data_images: true,
                            paste_preprocess: preProcessPaste,
                            object_resizing: true,
                          }" />
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-row class="ma-2">
                    <v-col cols="6" sm="4">
                      <v-btn class="ma-0 error eps_white" outlined @click="close()">Close
                        <i aria-hidden="true" class="v-icon notranslate v-icon--right mdi mdi-cancel theme--light"
                          style="font-size: 16px"></i>
                      </v-btn>
                    </v-col>
                    <v-col cols="6" sm="4">
                      <v-alert :type="alertType" dismissible close-text="Close Alert" border="left" dense
                        :value="showError" @input="showError = false"> {{
                          errorMessage
                        }}</v-alert>
                    </v-col>
                    <v-col cols="6" sm="4" class="text-right">
                      <v-btn class="ma-0 teal eps_white" outlined @click="reply()"
                        v-if="!(showReply || showNew || mailIsFromSystemUser)">
                        Reply
                        <i aria-hidden="true" class="v-icon notranslate v-icon--right mdi mdi-reply theme--light"
                          style="font-size: 16px"></i>
                      </v-btn>
                      <v-btn class="ma-0 teal eps_white" outlined @click="send()" :loading="mailSending"
                        v-if="showReply || showNew">
                        Send
                        <i aria-hidden="true" class="v-icon notranslate v-icon--right mdi mdi-send theme--light"
                          style="font-size: 16px"></i>
                      </v-btn>
                      <v-btn v-if="!showNew" class="ma-2 warning eps_white pa-2" outlined :loading="mailSendingToEmail"
                        @click="sendMessageToEmail()"
                        alt="Click here to send this message to your registerd email address">
                        Send To My Email
                        <i aria-hidden="true"
                          class="v-icon notranslate v-icon--center mdi mdi-email-newsletter theme--light"
                          style="font-size: 16px"></i>
                      </v-btn>


                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-dialog>

          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <br />
              <v-card-title class="text-h5 no-word-wrap">Are you sure you want to delete this mail?</v-card-title>
              <v-card-subtitle style="text-align:center" class="pa-2 ma-2" v-if="selectedMailItem">Selected mail "{{
                selectedMailItem.subject }}"</v-card-subtitle>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                <v-btn color="red darken-1" text @click="deleteItemConfirm">Delete</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

        </v-col>
        <v-spacer />
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import serverFunctions from "@/functions/serverFunctions";
import userFunctions from "@/functions/userFunctions";
import dateFunctions from "@/functions/dateFunctions";
import forumFunctions from "@/functions/forumFunctions";
import Editor from "@tinymce/tinymce-vue";
import contentUiCss from "!!raw-loader!tinymce/skins/ui/oxide/content.css";
import contentCss from "!!raw-loader!tinymce/skins/content/default/content.css";

import "tinymce/tinymce";
// /* A theme is also required */
import "tinymce/themes/silver/theme.min.js";

// /* Import the skin */
import "tinymce/skins/ui/oxide/skin.min.css";
import "tinymce/skins/ui/oxide/content.min.css";
import "tinymce/skins/content/default/content.min.css";

import "tinymce/models/dom/model";

import "tinymce/icons/default";

/* Import plugins */
import "tinymce/plugins/advlist";
import "tinymce/plugins/lists";
import "tinymce/plugins/link";
import "tinymce/plugins/anchor";
import "tinymce/plugins/emoticons";
import "tinymce/plugins/emoticons/js/emojis";
import "tinymce/plugins/link";
import "tinymce/plugins/anchor";
import "tinymce/plugins/media";

export default {
  name: "Mail",
  components: {
    editor: Editor,
  },
  computed: {
    smallScreen() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    newMailText() {
      return this.$vuetify.breakpoint.xsOnly ? "" : "New Mail";
    },
    getReplyUsername() {
      if (this.folder === 1) {
        return (
          this.selectedMailItem.userToSurname + ", " + this.selectedMailItem.userToForename
        );
      }
      return (
        this.selectedMailItem.userFromSurname +
        ", " +
        this.selectedMailItem.userFromForename
      );
    },
    filteredInbox() {
      if (this.inbox) {
        if (this.unreadOnly) {
          return this.inbox.filter((item) => !item.msgRead);
        }
        return this.inbox;
      }
      return null;
    },
    getHeaders() {
      switch (this.folder) {
        case 0:
          return [
            { text: "Delete", value: "actions", sortable: false },
            { text: "From", value: "userFrom", sortable: true, align: "start" },
            { text: "Subject", value: "subject", sortable: true },
            { text: "Sent On", value: "messageDate", sortable: true, align: "end" },
          ];
        case 1:
          return [
            { text: "Sent To", value: "userTo", sortable: true, align: "start" },
            { text: "Subject", value: "subject", sortable: true },
            { text: "Sent On", value: "messageDate", sortable: true, align: "end" },
          ];
        case 2:
          return [
            { text: "Sent From", value: "userFrom", sortable: true, align: "start" },
            { text: "Subject", value: "subject", sortable: true },
            { text: "Sent On", value: "messageDate", sortable: true, align: "end" },
          ];
      }
      return []
    }
  },
  methods: {
    preProcessPaste(plugin, args) {

      this.errorMessage = "";
      this.showError = false;

      let url = args.content;

      if (url.indexOf("blob:") <= 0) {
        return; //not a blob, continue
      }

      args.stopImmediatePropagation();
      args.stopPropagation();
      args.preventDefault();

      let start = url.indexOf("src=") + 5;
      let end = url.lastIndexOf("\"");
      url = url.substring(start, end);

      let blob = fetch(url).then(r => r.blob());
      let maxAlowableSize = 250000; //250Kb
      var pastedImageSize = -1;

      Promise.all([blob]).then((value) => {

        pastedImageSize = value[0].size

        if (pastedImageSize <= maxAlowableSize) {

          if (args.content) {
            if (this.editorContent == null) {
              this.editorContent = ""
            }
            this.editorContent = args.content + this.editorContent
          } else {
            this.editorContent = "";
          }
        } else {
          this.errorMessage = "The image you're pasting into the window is too large"
          this.alertType = "error"
          this.showError = true;
        }

      })
    },
    async getMail() {
      this.inbox = null;
      const inboxRequest = serverFunctions.getDataRequestObject(
        userFunctions.getLoggedInUser()
      );

      var mailEndpoint = ["/getInbox", "/getSentItems", "/getDeletedItems"][this.folder]

      this.inbox = await serverFunctions.getPostResponse(mailEndpoint, inboxRequest);
    },
    async getMailItem(messageId) {
      this.selectedMessage = null;
      const inboxRequest = serverFunctions.getDataRequestObject(
        userFunctions.getLoggedInUser(),
        messageId
      );
      let mailEndpoint = "/getMessage";
      let messageResponse = await serverFunctions.getPostResponse(mailEndpoint, inboxRequest);
      if (messageResponse && messageResponse.length > 0) {
        return messageResponse[0];
      }
      return null;
    },
    deleteItem(item) {
      this.selectedMailItem = item
      this.dialogDelete = true
    },
    closeDelete() {
      this.dialogDelete = false
    },
    async deleteItemConfirm() {
      let messageToDelete = this.selectedMailItem.messageId;

      this.deleteMailProcessing = true;

      const deleteMailRequest = serverFunctions.getDataRequestObject(
        userFunctions.getLoggedInUser(),
        messageToDelete
      );

      await serverFunctions.getRawPostResponse("/deleteMail", deleteMailRequest);

      userFunctions.updateUnreadMessageCount();

      this.selectedMailItem = null;
      this.mailSubject = null;

      this.deleteMailProcessing = false;

      this.getMail();
      this.closeDelete();

    },
    async getUsers() {
      this.users = await serverFunctions.getResponse("/getUsers");
    },
    getSelectedMailToUserId() {
      if (this.folder === 1) {
        return this.selectedMailItem.userTo;
      }
      return this.selectedMailItem.userFrom;
    },
    async send() {
      this.$refs.userForm.validate();
      if (!this.mailSubject || this.mailSubject.length == 0) {
        return;
      }
      let recipient = this.selectedMailItem
        ? this.getSelectedMailToUserId()
        : this.toUser;
      if (!recipient) {
        return;
      }
      this.mailSending = true;
      const sendMailRequest = serverFunctions.getSendMailRequestObject(
        userFunctions.getLoggedInUser(),
        null,
        recipient,
        this.mailSubject,
        this.editorContent
      );
      await serverFunctions.getRawPostResponse("/sendMail", sendMailRequest);
      this.selectedMailItem = null;
      this.mailSubject = null;
      userFunctions.updateUnreadMessageCount();
      this.mailSending = false;
      this.getMail();
      this.close();
    },
    async sendMessageToEmail() {
      this.mailSendingToEmail = true;
      this.showError = false;

      const sendMailToSelfRequest = serverFunctions.getDataRequestObject(
        userFunctions.getLoggedInUser(),
        this.selectedMailItem.messageId
      );

      let emailResponse = await serverFunctions.getRawPostResponse("/emailMessageToMyself", sendMailToSelfRequest);

      if (emailResponse && emailResponse.success) {
        this.alertType = "success"
        this.errorMessage = "Mail Sent"
        this.showError = true
      } else {
        this.alertType = "error"
        this.errorMessage = "Mail not sent, please try again"
        this.showError = true
      }


      this.mailSendingToEmail = false
    },
    async markMailAsRead(mailId) {
      const sendMailRequest = serverFunctions.getSendMailRequestObject(
        userFunctions.getLoggedInUser(),
        mailId
      );
      await serverFunctions.getRawPostResponse("/markMailAsRead", sendMailRequest);
      userFunctions.updateUnreadMessageCount();
      this.getMail();
    },
    getUsersName(user) {
      return user.surname + ", " + user.forename;
    },
    getSubject(mailItem) {
      return mailItem.subject
        .toLowerCase()
        .startsWith(this.replySubjectPrefix.toLowerCase())
        ? mailItem.subject
        : this.replySubjectPrefix + mailItem.subject;
    },
    focusEditor(e) {
      e.target.selection.collapse(false);
      e.target.selection.scrollIntoView();
    },
    writeNewMail() {
      this.selectedMailItem = null;
      this.mailSubject = null;
      this.editorContent = "";
      this.showNew = true;
      this.showMailDialog = true;
      this.showError = false;
      this.$nextTick(() => {
        this.$refs.userForm.validate()
      })
    },
    reply() {
      this.mailSubject = this.getSubject(this.selectedMailItem);
      this.editorContent = this.replyPrefix + this.selectedMailItem.message;
      this.showReply = true;
      this.showError = false;
    },
    close() {
      this.selectedMailItem = null;
      this.showReply = false;
      this.showNew = false;
      this.showMailDialog = false;
      this.showError = false;
    },
    async mailSelected(mail) {
      this.mailIsFromSystemUser = mail.isSystemMessage;
      this.showError = false;
      this.showReply = false;
      this.showNew = false;
      // this.selectedMailItem = mail;
      this.selectedMailItem = await this.getMailItem(mail.messageId);
      this.mailSubject = mail.subject;
      this.showMailDialog = true;
      if (this.folder != 1) {
        this.markMailAsRead(mail.messageId);
      }
    },
    formatMailTextForDisplay(post) {
      return forumFunctions.formatMailTextForDisplay(post);
    },
    formatPalmDateTime(date, time) {
      return dateFunctions.formatPalmDateTime(date, time);
    },
    getUnreadStyle(item) {
      return item.msgRead === 1 ? "read" : "unread";
    },
    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        if (index[0] === "messageDate") {
          if (isDesc[0]) {
            return a[index].messageDate + a[index].messageTime >
              b[index].messageDate + b[index].messageTime
              ? 1
              : -1;
          } else {
            return a[index].messageDate + a[index].messageTime >
              b[index].messageDate + b[index].messageTime
              ? -1
              : 1;
          }
        } else {
          if (!isDesc[0]) {
            return a[index] < b[index] ? -1 : 1;
          } else {
            return b[index] < a[index] ? -1 : 1;
          }
        }
      });
      return items;
    },
    customFilter(value, search, item) {
      return Object.keys(item).some(
        (v) =>
          v &&
          this.searchFields.indexOf(v) >= 0 &&
          item[v] &&
          item[v].toString().toLowerCase().includes(search.toLowerCase())
      );
    },
  },
  data: () => ({
    rules: {
      required: (value) => !!value || "Required",
    },
    inbox: null,
    users: null,
    toUser: null,
    showMailDialog: false,
    showReply: false,
    showNew: false,
    mailIsFromSystemUser: false,
    mailSubject: null,
    myHilitor: null,
    searchText: null,
    selectedMailItem: null,
    editorContent: null,
    errorMessage: null,
    alertType: "success",
    showError: false,
    contentUiCss: contentUiCss,
    contentCss: contentCss,
    mailSending: false,
    deleteMailProcessing: false,
    mailSendingToEmail: false,
    replyPrefix: "<br/><br/>-- Previous Message --<br/><br/>",
    replySubjectPrefix: "Re: ",
    searchFields: ["userFromForename", "userFromSurname", "subject", "message"],
    folders: [
      { name: "Inbox", id: 0 },
      { name: "Sent Items", id: 1 },
      { name: "Deleted Items", id: 2 },
    ],
    folder: 0,
    unreadOnly: false,
    dialogDelete: false,
  }),
  beforeMount() {
    this.getMail();
    this.getUsers();
    userFunctions.updateLastViewed('mail');
  },
  mounted() {
    if (this.$route.params.userId) {
      this.showMailDialog = true;
      this.showNew = true;
      let userId = parseInt(this.$route.params.userId);
      this.toUser = userId;
    }
  },
};
</script>

<style scoped>
.palm-site-green {
  background-color: rgb(176, 217, 173);
}

.read {
  font-weight: normal;
}

.unread {
  font-weight: bold;
}

.scroll {
  overflow-y: scroll;
}
</style>
